import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';

import { MatIcon } from '@angular/material/icon';

import { ESvgIcons } from '../../../../core/enums/svg-icons';
import { AiChatMobileComponent } from '../ai-chat-mobile/ai-chat-mobile.component';

@Component({
  selector: 'app-ai-chat-input-mobile',
  templateUrl: './ai-chat-input-mobile.component.html',
  styleUrls: ['./ai-chat-input-mobile.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [MatIcon, ReactiveFormsModule],
})
export class AiChatInputMobileComponent {
  @Input() aiChatMobileComponent: AiChatMobileComponent;
  @ViewChild('inputRef') inputRef: ElementRef;

  protected readonly eSvgIcons = ESvgIcons;

  formGroup = new FormGroup({
    value: new FormControl(''),
  });

  constructor(private cdr: ChangeDetectorRef) {}

  public sendMessageHandle(): void {
    this.aiChatMobileComponent.sendMessage();
  }

  public setExample(example: string): void {
    this.formGroup.controls['value'].setValue(example);
  }

  public reset(): void {
    this.formGroup.controls['value'].setValue('');
  }
}
